// extracted by mini-css-extract-plugin
export default {"imgContainer":"SvgIcon_imgContainer__TRmGV"};